import { render, staticRenderFns } from "./OriginalTable.vue?vue&type=template&id=59f98f18&scoped=true"
import script from "./OriginalTable.vue?vue&type=script&lang=js"
export * from "./OriginalTable.vue?vue&type=script&lang=js"
import style0 from "./OriginalTable.vue?vue&type=style&index=0&id=59f98f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f98f18",
  null
  
)

export default component.exports